/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentRegimenInvestigationObs from './treatment-regimen-investigation-obs';
import TreatmentRegimenInvestigationObsDetail from './treatment-regimen-investigation-obs-detail';
import TreatmentRegimenInvestigationObsUpdate from './treatment-regimen-investigation-obs-update';
import TreatmentRegimenInvestigationObsDeleteDialog from './treatment-regimen-investigation-obs-delete-dialog';

const TreatmentRegimenInvestigationObsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentRegimenInvestigationObs />} />
    <Route path="new" element={<TreatmentRegimenInvestigationObsUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentRegimenInvestigationObsDetail />} />
      <Route path="edit" element={<TreatmentRegimenInvestigationObsUpdate />} />
      <Route path="delete" element={<TreatmentRegimenInvestigationObsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentRegimenInvestigationObsRoutes;
